/**
 * 发票类型
 */
enum Transformtypenum { 
    未知发票类型 = '1',
    增值税专用发票 = '2',
    增值税普通发票INVOICE = '3',  
    机动车销售统一发票 = '5',
    增值税电子普通发票 = '6',
    增值税普通发票卷票 = '7',
    通行费发票 = '8',
    // EINVOICE_VAT = '增值税普通发票',
}

export default Transformtypenum;



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/entry/constant/TransformTypeNum/index.ts